import React from "react";
import * as hs from "@hlibs/react/hstyles";
import { HeaderFooterLayout } from "@hlibs/react-web/layouts";

import Header from "./Header";
import Footer from "./Footer";

const defaultProps = {
  maxWidth: 1920,
  maxHeight: 1080,

  minWidth: 600,
};

const defaultStyles = {};

const LoginLayout = (props) => {
  const mergedProps = hs.mergeProps(defaultProps, props);

  const styles = hs.mergeStyles(defaultStyles, mergedProps.style);

  const { children } = props;

  const headerComponent = <Header />;
  const footerComponent = <Footer />;

  return (
    <HeaderFooterLayout
      header={headerComponent}
      footer={footerComponent}
      maxWidth={mergedProps.maxWidth}
      maxHeight={mergedProps.maxHeight}
      style={[styles]}
    >
      {children}
    </HeaderFooterLayout>
  );
};

export default LoginLayout;
